/**
 * Converts the given {@link date} to a ABAP specific time type.
 */
export const toABAPTime = (date: Date): string => {
  const offset = date.getTimezoneOffset();
  const time = new Date(date.getTime() - offset * 60 * 1000);
  const result = time.toLocaleTimeString();
  return result.replaceAll(":", "");
};
